module.exports = __webpack_public_path__ + "img/facepalm.dc2affee.gif";